import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tasks" }
const _hoisted_2 = { class: "opts" }
const _hoisted_3 = { class: "opts" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_TasksRunner = _resolveComponent("TasksRunner")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TasksRunner, {
      class: "runner",
      "can-run": $data.companies_filelist.length > 0,
      "runner-id": "adm_import_companies_csv",
      caption: "Import Companies",
      runner: (tasks) => $options.runImport(tasks, 'companies')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_upload, {
            ref: "companies_csv_file",
            "file-list": $data.companies_filelist,
            "onUpdate:fileList": _cache[0] || (_cache[0] = $event => (($data.companies_filelist) = $event)),
            class: "upload-csv",
            "on-exceed": (files) => $options.handleExceed(files, 'companies'),
            limit: 1,
            "auto-upload": false,
            accept: ".csv",
            "on-change": (file) => $options.onFileChange(file, 'companies')
          }, {
            trigger: _withCtx(() => [
              _createVNode(_component_Button, { class: "attach-button" }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" Attach companies CSV ")
                ])),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["file-list", "on-exceed", "on-change"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["can-run", "runner"]),
    _createVNode(_component_TasksRunner, {
      class: "runner",
      "can-run": $data.contacts_filelist.length > 0,
      "runner-id": "adm_import_contacts_csv",
      caption: "Import Contacts",
      runner: (tasks) => $options.runImport(tasks, 'contacts')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_upload, {
            ref: "contacts_csv_file",
            "file-list": $data.contacts_filelist,
            "onUpdate:fileList": _cache[1] || (_cache[1] = $event => (($data.contacts_filelist) = $event)),
            class: "upload-csv",
            "on-exceed": (files) => $options.handleExceed(files, 'contacts'),
            limit: 1,
            "auto-upload": false,
            accept: ".csv",
            "on-change": (file) => $options.onFileChange(file, 'contacts')
          }, {
            trigger: _withCtx(() => [
              _createVNode(_component_Button, { class: "attach-button" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Attach contacts CSV ")
                ])),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["file-list", "on-exceed", "on-change"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["can-run", "runner"])
  ]))
}